exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "footer {\n  background: #0A0A0A;\n  color: white;\n  padding-top: 40px;\n  margin-top: 200px; }\n  footer h3 {\n    font-size: 1em;\n    font-weight: 500; }\n    footer h3 + div {\n      background: rgba(255, 255, 255, 0.3);\n      margin: 5px 0;\n      height: 3px;\n      width: 40px; }\n  footer p {\n    font-size: 1em;\n    font-weight: 100; }\n  footer .bottom {\n    background: black;\n    padding: 10px;\n    font-size: 0.875em;\n    font-weight: 100; }\n    footer .bottom .text-center {\n      opacity: 0.6; }\n      footer .bottom .text-center span {\n        font-weight: 700; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Mustafa/Developpement/noxoe/src/components/footer/footer.component.scss
// module id = ../../../../../src/components/footer/footer.component.scss
// module chunks = main